export default __webpack_public_path__ + "img/publication/publication6_1500.webp";